<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ dispatch_type.id ? "Editar" : "Novo" }} Tipo de Despacho
              </div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span> Nome:
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="dispatch_type.name"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label for="Name"
                        ><span class="required">*</span> Empresa:
                      </label>
                      <v-select
                        :options="companies"
                        :reduce="(companies) => companies.id"
                        :label="'name'"
                        v-model="dispatch_type.tenancy_id"
                        class="vselect"
                      />
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span> Descrição:
                      </label>
                      <textarea
                        class="form-control"
                        cols="30"
                        rows="1"
                        v-model="dispatch_type.description"
                      ></textarea>
                    </div>
                    <div class="form-group col-md-6">
                      <label for="inputUser">
                        <span class="required">*</span> Status:
                      </label>
                      <select
                        v-model="dispatch_type.status"
                        class="form-control"
                      >
                        <option :value="1">Ativo</option>
                        <option :value="0">Inativo</option>
                      </select>
                    </div>
                  </div>

                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong>Campos obrigatórios</strong>
                  </span>
                  <div class="block text-right">
                    <router-link to="/dispatch_types" class="btn btn-back mr-1">
                      <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                    <a v-if="$hasAbility('node.admin')" class="btn btn-add" @click="save">
                      Salvar
                      <i class="fa fa-save"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import Loading from "vue-loading-overlay";

export default {
  data() {
    return {
      dispatch_type: {
        name: "",
        description: "",
        tenancy_id: "",
        status: "1",
      },
      companies: [],
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "dispatch_types";

      if (self.dispatch_type.id) {
        self.dispatch_type._method = "PUT";
        api += "/" + self.dispatch_type.id;
      }

      self.$loading(true);

      axios
        .post(api, self.dispatch_type)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.$loading(false);
          this.$router.push("/dispatch_types");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getCompanies: function () {
      const self = this;
      let api = self.$store.state.api + "companies?paginated=false&status=1";

      axios
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getDispatchType: function (id) {
      const self = this;
      const api = self.$store.state.api + "dispatch_types/" + id;
      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.dispatch_type = response.data.data[0];
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    self.getCompanies();

    let id = self.$route.params.id;
    if (id) {
      self.getDispatchType(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
    Loading,
  },
};
</script>
<style scoped>
.custom-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 255, 128, 0);
  backdrop-filter: blur(3px);
  opacity: 0.98;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.custom-loading-spinner {
  width: 100px;
  height: 100px;
  z-index: 10000;
}

.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>